import { sanityClient } from "./sanityClient";

export async function fetchGalleryYears() {
  return sanityClient.fetch(
    `*[_type == "galleryYear"] | order(year desc) { year, photos, winnerPhotos }`
  );
}
